import clsx from 'clsx'
import React from 'react'
import Note from '../Note'
import { NoteType } from '../../enums/NoteType'
import SupportEmailLink from '../SupportEmailLink'
import Button from '../Button'
import {
    FieldValues,
    SubmitHandler,
    UseFormHandleSubmit,
} from 'react-hook-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/free-solid-svg-icons'

type Props<TFormData extends FieldValues> = {
    children: React.ReactNode | React.ReactNode[]
    className?: string
    apiError?: string
    entityName: string
    cancelTo: string
    handleSubmit: UseFormHandleSubmit<TFormData>
    onSubmit: SubmitHandler<TFormData>
    isSubmitting: boolean
}

function Form<TFormData extends FieldValues>({
    children,
    className,
    apiError,
    entityName,
    cancelTo,
    handleSubmit,
    onSubmit,
    isSubmitting,
}: Props<TFormData>): React.JSX.Element {
    const classes = clsx(
        'max-w-[600px] p-4 border border-gray-300 rounded-lg bg-white',
        className,
    )

    return (
        <form
            className="bg-gray-50 p-4 mt-4 rounded-lg"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className={classes}>
                {children}

                <div className="flex justify-end gap-2">
                    <Button type="link" to={cancelTo} style="mild-danger">
                        Cancel
                    </Button>
                    <Button type="submit" style="primary">
                        <FontAwesomeIcon icon={faSave} className="mr-2" />
                        {isSubmitting ? 'Saving...' : 'Save'}
                    </Button>
                </div>
                {apiError && (
                    <Note type={NoteType.ERROR} containerClassNames="mb-4">
                        <div>
                            There was a problem saving the {entityName}. Please
                            try again or contact <SupportEmailLink /> if the
                            problem persists.
                        </div>
                        <div className="mt-2">Error details: {apiError}</div>
                    </Note>
                )}
            </div>
        </form>
    )
}

export default Form
